import React, { FC, useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { numberWithSpaces } from '../../../utils/math';
import { AnimatedLink } from '../../../components/animated-link/AnimatedLink';
import { LawFirmContext } from '../LawFirmContext';

export const LawFirmHeaderDecisionsLink: FC = () => {
  const {
    experience: { decisionCount },
    allDecisionsLink,
  } = useContext(LawFirmContext);

  if (!decisionCount) return null;

  return (
    <AnimatedLink
      href={allDecisionsLink}
      source="read_all_law_firm_decisions_from_header"
    >
      <span>
        <FormattedMessage
          id="header/LawFirmHeaderDecisionsLink.tsx/1"
          values={{
            count: decisionCount,
            countFormatted: numberWithSpaces(decisionCount),
          }}
        />
      </span>
    </AnimatedLink>
  );
};
